import { CityResponse } from "../types/talk-to-loan-expert-types.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, request } from "../core/api.client";

export const getTalkToLoanExpertData = async (data: {
  key: string;
}): Promise<IResponse<CityResponse> | null> => {
  try {
    const response = await request<CityResponse>({
      method: "POST",
      url: API_PATHS.talkToLoanExpert,
      data,
    });
    return response;
  } catch (error) {
    console.error("Error fetching loan expert data:", error);
    return null;
  }
};
